export enum VEHICLE {
  UN_AUTHENTICATED_KEY = 'unAuthenticatedVehicleKey',
  START_KEY = 'startVehicle',
  ENTITLEMENTS_KEY = 'vehicleEntitlements',
  PREFERENCES_KEY = 'vehiclePreferences',
  REMOVAL_REASONS = 'vehicleRemovalReasons',
  RESPONSE_KEY = 'vehicles',
  SERVICE_CATEGORIES_KEY = 'vehicleServiceCategories',
  SERVICE_RECORDS_KEY = 'vehicleServiceRecords',
  YEARS_KEY = 'Years'
}
export enum ACTIVE_VEHICLE {
  KEY = 'activeVehicle',
  MILEAGE_UPDATED_KEY = 'activeVehMileageUpdatedKey',
  NOTIFICATIONS_KEY = 'notifications'
}
export const VEHICLE_KEYS = {
  ...VEHICLE,
  ACTIVE: ACTIVE_VEHICLE
} as const;
